module.exports = __webpack_public_path__ + "media/customizations/midwaypark/back-c39950e05e93f3d7937e6c4e656e3a08.jpg";